"use client";

import { useLanguage } from "@/i18n/LanguageContext";

export default function KnownLimitationsSection() {
  const { t } = useLanguage();
  const items = t("access.limitationsList") as string[];

  return (
    <section className="bg-white py-12 md:py-16 px-4 md:px-6">
      <div className="max-w-[880px] mx-auto">
        <h2 className="text-xl md:text-[28px] font-black text-[#064e3b] mb-4">
          {t("access.h2Limitations")}
        </h2>
        <p className="text-[#374151] leading-[1.7] mb-4">
          {t("access.limitationsText")}
        </p>
        <ul className="space-y-3 mb-6">
          {items.map((item) => (
            <li key={item} className="flex items-start gap-3 text-[#374151]">
              <span className="mt-0.5 w-5 h-5 flex items-center justify-center text-[#047857] flex-shrink-0">
                <i className="ri-checkbox-circle-line" />
              </span>
              {item}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}